export default function IconSymbolKitchen(props) {
  return (
    <svg width="16" height="16" viewBox="-30 -55 60 110" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" {...props}>
      <rect x="-25.3" y="-50" width="50.6" height="100"/><rect x="-19" y="-43.6" width="37" height="15.6"/><circle cx="-14.1" cy="-10.5" r="5.3"/>
    </svg>
  )
}
